import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import jQuery from "jquery";

class Demo {
  init() {
    this.initPage();
    this.initParallax();
    this.onResize();
  }

  initPage = () => {
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    //customAnmation.animateBgImage('.demo_background', '.demo');
    //customAnmation.animateScaleDown('.demo_form');
    //customAnmation.animateText('.demo_text');
  }

  onResize = () => {
    jQuery(window)
      .resize(function () {
        let h = jQuery(window).height() - jQuery('.footer').outerHeight();
        jQuery('.demo').css("min-height", h + 'px');

      })
      .resize();
  };
}

export default Demo;
